import React, { ReactNode, useState, useEffect } from 'react'
import cx from 'classnames'

import './sticky-bar.scss'

export type StickyBarProps = {
  children?: ReactNode | string
  className?: string
  position?: 'top' | 'bottom'
  scrollPositionBreakpoint?: number
  scrollPositionBreakpointEnd?: number
}

export function StickyBar({
  className,
  children,
  position = 'bottom',
  scrollPositionBreakpoint = 200,
  scrollPositionBreakpointEnd = 5700,
}: StickyBarProps) {
  const [scrollPosition, setSrollPosition] = useState(0)
  const handleScroll = () => {
    setSrollPosition(window.pageYOffset)
  }

  useEffect(() => {
    document.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div
      className={cx('sticky-bar', className, {
        [`fixed-${position}`]:
          scrollPosition > scrollPositionBreakpoint &&
          scrollPosition < scrollPositionBreakpointEnd,
      })}
    >
      {children}
    </div>
  )
}
